import { RegistrationStatus } from '@/types/tournament.model';

// Allowlist (not a blocklist): an unknown/future status defaults to inactive, which leaves its
// players unreplaceable, its hours uneditable and its payments out of the cancellation notice.
const ACTIVE_REGISTRATION_STATUSES = new Set<RegistrationStatus>([
  RegistrationStatus.PENDING_PAYMENT,
  RegistrationStatus.PENDING_ADMIN_CHECK,
  RegistrationStatus.PARTIALLY_PAID,
  RegistrationStatus.COMPLETE,
]);

export const isActiveRegistration = (status: RegistrationStatus): boolean =>
  ACTIVE_REGISTRATION_STATUSES.has(status);
